import { ar } from "./catalog/ar";
import { en } from "./catalog/en";
import { ro } from "./catalog/ro";
import { ru } from "./catalog/ru";
import type { Locale, MessageCatalog } from "./types";

export const messagesByLocale: Readonly<Record<Locale, MessageCatalog>> = {
  en,
  ar,
  ru,
  ro
};

export function messagesForLocale(locale: Locale): MessageCatalog {
  return messagesByLocale[locale];
}
